@if (!pageLoadComplete()) {
  <is-wait-message [loadComplete]="pageLoadComplete()" [waitMessage]="'Please wait while we process your request.'" [useBolt]="false" [timeoutAmount]="0"></is-wait-message>
}

<div class="bolt-container bolt-space-bottom-2xl">
  <bolt-progress-bar appFocusOnInit arialabel="Cancel scheduled payment progress value is 100%" value="100" class="progress-bar-container to-container"></bolt-progress-bar>
  <h1 class="bolt-heading-primary bolt-space-bottom-2xl page-title">Cancel scheduled payment: confirmation</h1>

  <div class="main-container">
    @if (!apiCallSuccessful) {
      <bolt-notification type="error">
        <span class="error-notification">We are unable to process your request. For assistance, please contact us.</span>
      </bolt-notification>

    } @else {
      <bolt-notification type="success" class="bolt-space-bottom-2xl to-container">
        <span class="success-notification">Your payment has been canceled.</span>
      </bolt-notification>
      <section id="payment-due">
        <app-payment-sub-header>Outstanding payment due</app-payment-sub-header>
      </section>
      <div class="main-contents">
        <p>A payment of {{ paymentAmount }} is due for this account on {{ nextDueDate }}. To make a payment, select Make a payment.</p>
      </div>
    }
  </div>
</div>

@if (apiCallSuccessful) {
  <bolt-button-bar>
    <is-button id="print-button" slot="cancel" (click)="showPrintDialog()">Print</is-button>
    <is-button id="secondary-button" slot="back" (click)="navigateToBillingPreferences()">Payment preferences</is-button>
    <is-button id="submit-button" slot="forward" [type]="solid" (click)="navigateToMakeAPayment()">Make a payment</is-button>
  </bolt-button-bar>
} @else {
  <bolt-button-bar>
    <is-button id="print-button" slot="cancel" (click)="showPrintDialog()">Print</is-button>
    <is-button id="secondary-button" slot="forward" (click)="navigateToBillingPreferences()">Payment preferences</is-button>
  </bolt-button-bar>
}
